<template>
    <input placeholder="search..." :class="{'focused':focused}" @focus="focused=true" @blur="focused=false" :value="value" @input="$emit('input', $event.target.value)" />
</template>
<script>
    export default {
        name: 'SearchInput',
        data: function (){
            return {
                focused: false
            }
        },
        props: ['value']
    };
</script>

<style scoped>
    .focused{
        animation-name: searchbox;
        animation-delay: 0s;
        animation-timing-function: linear;
        animation-fill-mode: both;
        animation-duration: 0.3s;
    }

    @keyframes searchbox {
        0% {

        }

        100% {
            flex: 1;
            width: available;
        }
    }
</style>
